import type { BreedFciGroupType, BreedMaintenanceType } from '@application/types';
import type { AnimalSizeEnum, DogHairType, DogType } from '@gql/graphql';
import type {
  CardItemBreedData,
  CardItemPromoData,
  FiltersWithModalData,
  InputSelectData,
  PaginationData,
} from '@presentation/components';

export interface BreedListPageFormValues {
  allergic?: boolean;
  independant?: boolean;
  size?: AnimalSizeEnum[];
  dogType?: DogType[];
  maintenanceType?: BreedMaintenanceType[];
  fciGroupType?: BreedFciGroupType[];
  hairType?: DogHairType[];
}

export interface BreedListPageData {
  items: (CardItemBreedData | CardItemPromoData)[];
  isPromoItem: (index: number, size: number) => boolean;

  searchInput: InputSelectData<string>;

  pagination: PaginationData;
  loading?: boolean;
  filtersModal: FiltersWithModalData;
}

export interface BreedListPageProps extends BreedListPageData {}
